var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import '../../../components/score';
import { Header } from './Header';
import { Feedback } from './Feedback';
import { GiveFeedback } from './GiveFeedback';
import { isEmpty } from '../../../utils/stringUtils';
import './PrivateListingButtonGroup';
import { Reply } from './Reply';
import { BaseComponent } from '../../../utils/BaseComponent';
import { provide } from '@lit-labs/context';
import { reportContext } from '../context/ReportContext';
import { replyContext } from '../context/ReplyContext';
let ListItem = class ListItem extends BaseComponent {
    constructor() {
        super(...arguments);
        this.report = {
            show: false,
            tradeHappened: undefined,
            sensitive: undefined,
            error: false,
            input: '',
            setContext: (context) => {
                this.report = { ...this.report, ...context };
            },
            reset: () => {
                this.report = {
                    ...this.report,
                    show: false,
                    tradeHappened: undefined,
                    sensitive: undefined,
                    error: false,
                    input: '',
                };
            },
        };
        this.reply = {
            show: false,
            input: '',
            setContext: (context) => {
                this.reply = { ...this.reply, ...context };
            },
            reset: () => {
                this.reply = {
                    ...this.reply,
                    show: false,
                    input: '',
                };
            },
        };
    }
    willUpdate(_changedProperties) {
        var _a, _b, _c, _d, _e;
        if (_changedProperties.has('privateListing') && this.privateListing !== undefined) {
            this.report.setContext({
                tradeId: (_a = this.privateListing) === null || _a === void 0 ? void 0 : _a.tradeId,
                externalItemId: typeof ((_b = this.privateListing) === null || _b === void 0 ? void 0 : _b.itemExternalId) === 'string' ? (_c = this.privateListing.itemExternalId) === null || _c === void 0 ? void 0 : _c.split(":").at(-1) : undefined,
            });
            this.reply.setContext({
                tradeId: (_d = this.privateListing) === null || _d === void 0 ? void 0 : _d.tradeId,
                tradeToken: (_e = this.privateListing) === null || _e === void 0 ? void 0 : _e.tradeToken,
            });
        }
    }
    render() {
        var _a, _b;
        return html `
      ${Header({
            isSeller: this.privateListing.isSeller,
            itemTitle: this.privateListing.itemTitle,
        })}
      ${isEmpty(this.giveFeedbackUrl)
            ? html `
            ${Feedback(this.me, this.other, this.profileUrl, this.feedbackGiven)}
            <div class="mt-16">
              ${Reply({
                reply: this.feedbackGiven ? this.me.reply : this.other.reply,
                isReplierSeller: this.feedbackGiven
                    ? this.other.role === 'SELLER'
                    : this.me.role === 'SELLER',
                feedbackGiven: this.feedbackGiven,
            })}
            </div>
            <trust-private-listing-button-group
              .me=${this.me}
              .other=${this.other}
              token="${this.privateListing.tradeToken}"
              deleteUrl="${(_b = (_a = this.me.feedback) === null || _a === void 0 ? void 0 : _a._links.self.href) !== null && _b !== void 0 ? _b : ''}"
              ?feedbackGiven="${this.feedbackGiven}"
              profileUrl="${this.profileUrl}"
            >
            </trust-private-listing-button-group>
          `
            : GiveFeedback({
                giveFeedbackUrl: this.giveFeedbackUrl,
                expiryDate: this.privateListing.expiryDate,
                tradeId: this.privateListing.tradeId,
                name: this.other.name,
            })}
    `;
    }
};
__decorate([
    provide({ context: reportContext }),
    state()
], ListItem.prototype, "report", void 0);
__decorate([
    provide({ context: replyContext }),
    state()
], ListItem.prototype, "reply", void 0);
__decorate([
    property()
], ListItem.prototype, "privateListing", void 0);
__decorate([
    property()
], ListItem.prototype, "me", void 0);
__decorate([
    property()
], ListItem.prototype, "other", void 0);
__decorate([
    property()
], ListItem.prototype, "profileUrl", void 0);
__decorate([
    property({ type: Boolean })
], ListItem.prototype, "feedbackGiven", void 0);
__decorate([
    property()
], ListItem.prototype, "giveFeedbackUrl", void 0);
ListItem = __decorate([
    customElement('trust-private-listing-list-item')
], ListItem);
export { ListItem };
//# sourceMappingURL=ListItem.js.map